<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100 pt-70-pb-70-pr-40">
        <div class="onboarding-canvas h-100">
            <grid-row class="justify-content-center align-content-between pb-30 h-100">
                <grid-col col="12">
                    <grid-row class="mt-15 mt-mobile-0">
                        <grid-col col="8">
                            <div class="font-400 font-size-20px line-h-25">
                                {{ "EnterInsNickname" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                    <div class="form-group mt-40">
                        <label class="no-mark">
                            {{ "InsPolicyNickname" | translate }}
                        </label>
                        <input type="text" placeholder="Please enter" [(ngModel)]="this.InspolicyName">
                    </div>
                </grid-col>
                <grid-col col="12">
                    <grid-row class="justify-content-between mt-20">
                        <grid-col col="auto">
                            <button class="btn-back" (click)="back()">
                                <i class="icon-back"></i>
                            </button>
                        </grid-col>
                        <grid-col col="9">
                            <button class="btn-dft-border p-17" (click)="this.showModal(1)"
                                *ngIf="this.InspolicyName != ''">
                                {{ "RemoveNickName" | translate }}
                            </button>
                            <button class="btn-dft" [disabled]="isValid()" (click)="updateNickName('')"
                                *ngIf="this.InspolicyName == ''">
                                {{ "SAVE" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-center mt-24" *ngIf="this.InspolicyName != ''">
                        <grid-col col="12">
                            <button class="btn-dft" [disabled]="isValid()" (click)="updateNickName('')">
                                {{ "SAVE" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>

<!--Modal Open -->
<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="CONFIRM"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="updateNickName('remove')">
    <div class="text-align-center">
        <ng-icon iconClass="icon-remove-modal" width="72" height="72"></ng-icon>
        <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
            {{ "RemoveNickName" | translate }}
        </div>
        <div class="font-400 font-size-14px line-h-20 color-base-500 p-10">
            {{ "AreYouSureToRemoveCard" | translate }}
        </div>
    </div>
</modal>
<!-- Modal Close  -->